<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DsS3Lu/tc-custom/9781453255971.jpg?1708803118472" alt="This image is the cover for the book Americans, The Kent Family Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Americans, The Kent Family Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <b>The conclusion of the epic historical family saga from the #1 <i>New York Times</i>–bestselling author and “superb storyteller” (<i>The Columbus Dispatch</i>).</b><br/>  In the final installment of the Kent Family Chronicles, the remaining Kents seek to fulfill Philip Kent’s original American dream. As Gideon Kent’s health deteriorates, he fears for the future of his family. Their dynasty, now in ruins, stands as a tarnished symbol of all the Kents have lost in the unstable years of war and expansion. It falls to young Will to bring the family together—a task of epic scope. Only expert storyteller John Jakes could craft such a gripping finale to this beloved family saga, bringing the Kents’ drama—and the nineteenth century in America—to its riveting conclusion. <i>This ebook features an illustrated biography of John Jakes including rare images from the author’s personal collection.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Jakes
      </h2>
      
      <p class="authorDescription body article">John Jakes (b. 1932), the author of more than a dozen novels, is regarded as one of today&rsquo;s most distinguished writers of historical fiction. His work includes the highly acclaimed Kent Family Chronicles series and the North and South Trilogy. Jakes&rsquo;s commitment to historical accuracy and evocative storytelling earned him the title of &ldquo;the godfather of historical novelists&rdquo; from the <I>Los Angeles Times</I> and led to a streak of sixteen consecutive <I>New York Times</I> bestsellers. Jakes has received several awards for his work and is a member of the Authors Guild and the PEN American Center. He and his wife, Rachel, live on the west coast of Florida.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e816429